import "./returnsPolicy.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRotate,
  faShieldHalved,
  faTriangleExclamation,
  faHeadset,
} from "@fortawesome/free-solid-svg-icons";

export default function ReturnsPolicy() {
  return (
    <main className="returnsPage">
      <div className="returnsContainer">
        <h1><FontAwesomeIcon icon={faShieldHalved} className="returnsIconLarge" /> Returns & Exchange Policy</h1>

        <div className="returnsIntro">
          <p>At Tote Therapy, we prioritize quality and customer satisfaction.</p>
        </div>

        <div className="returnsCard">
          <div className="returnsHeader">
            <FontAwesomeIcon icon={faRotate} className="returnsIcon" />
            <h2>Exchange Eligibility</h2>
          </div>

          <p>All items are considered final sale.</p>
          <p>We accept exchanges only in cases of manufacturing defects. To be eligible:</p>

          <ul className="returnsList">
            <li>The issue must be reported within 48 hours of delivery</li>
            <li>The item must be unused and in original condition</li>
            <li>Proof of purchase is required</li>
          </ul>

          <p>If approved, we will arrange an exchange.</p>
        </div>

        <div className="returnsCard warning">
          <div className="returnsHeader">
            <FontAwesomeIcon icon={faTriangleExclamation} className="returnsIcon" />
            <h2>Please Note</h2>
          </div>
          <p>We do not offer refunds for change of mind.</p>
        </div>

        <div className="returnsCard support">
          <div className="returnsHeader">
            <FontAwesomeIcon icon={faHeadset} className="returnsIcon" />
            <h2>Need Support?</h2>
          </div>
          <p>For support, contact us via WhatsApp or email.</p>
        </div>
      </div>
    </main>
  );
}